// src/react-auth0-spa.js
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

export const PageContext = React.createContext();

export const usePageContext = () => useContext(PageContext);

const PageContextProvider = ({ children }) => {
  const [pageContext, setPageContext] = useState('login');

  return (
    <PageContext.Provider
      value={{
        pageContext,
        setPageContext,
      }}
    >
      <>{children}</>
    </PageContext.Provider>
  );
};

PageContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageContextProvider;
